(() => {
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  const reveal = (root = document) => root.querySelectorAll('.pl-reveal:not(.is-visible)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-visible')));
  reveal();
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));

  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  };
  document.querySelectorAll('[data-pl-delivery]').forEach((el) => {
    const min = parseInt(el.dataset.min, 10) || 1;
    const max = parseInt(el.dataset.max, 10) || 3;
    const a = addBusinessDays(new Date(), min);
    const b = addBusinessDays(new Date(), Math.max(min, max));
    const full = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });
    const dayOnly = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric' });
    const sameMonth = a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
    const out = el.querySelector('[data-pl-delivery-range]');
    if (out) out.textContent = `${sameMonth ? dayOnly.format(a) : full.format(a)} – ${full.format(b)}`;
  });

  const plMoney = (cents) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
  let plProduct = null;
  const loadProduct = async () => {
    if (plProduct || !location.pathname.includes("/products/")) return plProduct;
    try { plProduct = await (await fetch(location.pathname.replace(/\/$/, "") + ".js")).json(); } catch (e) { plProduct = null; }
    return plProduct;
  };
  const decorateBundles = async () => {
    const sets = [...document.querySelectorAll("variant-selects fieldset")].filter((fs) => /paket|menge|set/i.test(fs.querySelector("legend")?.textContent || ""));
    if (!sets.length) return;
    const product = await loadProduct();
    sets.forEach((fs) => {
      fs.classList.add("pl-bundle");
      const idx = product ? product.options.findIndex((o) => /paket|menge|set/i.test(o.name || o)) : -1;
      const priceFor = (val) => {
        if (!product || idx < 0) return null;
        const vs = product.variants.filter((v) => v.options[idx] === val);
        return vs.length ? Math.min(...vs.map((v) => v.price)) : null;
      };
      const inputs = [...fs.querySelectorAll("input[type=radio]")];
      const single = inputs.map((i) => ({ n: parseInt((i.value.match(/\d+/) || ["1"])[0], 10), p: priceFor(i.value) })).find((x) => x.n === 1)?.p;
      const legend = fs.querySelector("legend");
      if (legend && !legend.dataset.pl) { legend.dataset.pl = "1"; legend.innerHTML = '<span class="pl-bundle__head">Mehr kaufen – mehr sparen</span>'; }
      const noun = (document.querySelector(".product__title h1")?.textContent || "Kissen").trim().replace(/^Das\s+/i, "");
      const subs = { 1: "Zum Ausprobieren", 2: "Für euch zwei", 3: "Für die ganze Familie", 4: "Für die ganze Familie" };
      const HEART = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M12 21s-7.5-4.6-9.6-9.3C.9 8.2 3.1 4.5 6.8 4.5c2 0 3.5 1.1 5.2 3 1.7-1.9 3.2-3 5.2-3 3.7 0 5.9 3.7 4.4 7.2C19.5 16.4 12 21 12 21z"/></svg>';
      const TAG = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M3 12.6V4.5C3 3.7 3.7 3 4.5 3h8.1c.4 0 .8.2 1.1.4l7.9 7.9c.6.6.6 1.5 0 2.1l-8.1 8.1c-.6.6-1.5.6-2.1 0l-7.9-7.9c-.3-.3-.5-.7-.5-1zM7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/></svg>';
      const badges = { 2: "<span>Unsere<br>Empfehlung</span>", 3: "<span>Bester Preis</span>", 4: "<span>Bester Preis</span>" };
      inputs.forEach((input) => {
        const label = fs.querySelector(`label[for="${input.id}"]`);
        if (!label || label.querySelector(".pl-bundle__card")) return;
        const n = parseInt((input.value.match(/\d+/) || ["1"])[0], 10);
        const price = priceFor(input.value);
        const save = single && n > 1 && single * n > price ? single * n - price : 0;
        const name = n === 1 ? "1 Kissen" : `${n} Kissen`;
        label.innerHTML = `<span class="pl-bundle__card">
          ${badges[n] ? `<span class="pl-bundle__badge">${badges[n]}</span>` : ""}
          <span class="pl-bundle__dot" aria-hidden="true"></span>
          <span class="pl-bundle__txt"><b>${name}</b><small>${save ? `<span class="pl-bundle__save">Du sparst ${plMoney(save)}</span>` : (subs[n] || "")}</small></span>
          <span class="pl-bundle__price">${price != null ? `<b>${plMoney(price)}</b>` : ""}${n > 1 && price != null ? `<small>${plMoney(Math.round(price / n))} / Stück</small>` : ""}${save ? `<small class="pl-bundle__single">einzeln ${plMoney(single * n)}</small>` : ""}</span>
        </span><span class="visually-hidden">${input.value}</span>`;
      });
    });
  };
  decorateBundles();
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
      setTimeout(decorateBundles, 0);
      const v = ev?.data?.variant;
      document.querySelectorAll("[data-pl-satc-price]").forEach((el) => { if (v) el.textContent = plMoney(v.price); });
    });
  }
  document.addEventListener('shopify:section:load', decorateBundles);

  class PlStickyAtc extends HTMLElement {
    connectedCallback() {
      const main = document.querySelector('product-form button[type="submit"]');
      if (!main) return;
      this.hidden = false;
      const obs = new IntersectionObserver(([e]) => this.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 });
      obs.observe(main);
      this.querySelector('[data-pl-satc-buy]')?.addEventListener('click', () => {
        main.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => main.click(), 350);
      });
    }
  }
  if (!customElements.get('pl-sticky-atc')) customElements.define('pl-sticky-atc', PlStickyAtc);

  // Zusatzartikel (z. B. Wolkenbezug): passende Farbe zur gewählten Kissen-Variante vorschlagen
  const syncAddons = () => {
    document.querySelectorAll('[data-pl-addon]').forEach((el) => {
      let variants = [];
      try { variants = JSON.parse(el.querySelector('[data-pl-addon-variants]')?.textContent || '[]'); } catch (e) { variants = []; }
      if (!variants.length) return;
      const mi = parseInt(el.dataset.mainIndex, 10), ui = parseInt(el.dataset.upIndex, 10);
      let pick = variants.find((v) => String(v.id) === el.dataset.variantId) || variants.find((v) => v.available) || variants[0];
      if (mi >= 0 && ui >= 0) {
        const info = document.getElementById(`MainProduct-${el.dataset.sectionId}`);
        let sel = null;
        try { sel = JSON.parse(info?.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null'); } catch (e) { sel = null; }
        const val = sel?.options?.[mi];
        const match = val && variants.find((v) => v.available && v.options[ui] === val);
        if (match) pick = match;
      }
      el.dataset.variantId = String(pick.id);
      const color = el.querySelector('[data-pl-addon-color]');
      if (color && ui >= 0) color.textContent = (color.textContent.includes('·') ? ' · ' : '') + pick.options[ui];
      const price = el.querySelector('[data-pl-addon-price]');
      if (price) price.textContent = plMoney(pick.price);
      const img = el.querySelector('.pl-addon__img img');
      if (img && pick.image) { img.src = pick.image; img.removeAttribute('srcset'); }
    });
  };
  syncAddons();
  document.addEventListener('shopify:section:load', syncAddons);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncAddons, 0));

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pl-upsell]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    const drawer = document.querySelector('cart-drawer');
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.plUpsell), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents({ ...data, id: Number(btn.dataset.plUpsell) });
      } else {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }
    } catch (err) {
      btn.removeAttribute('aria-busy');
    }
  });

  // Warenkorb: Einzelkissen gegen 2er-Set derselben Farbe tauschen (nur auf Klick)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pl-swap-key]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    const drawer = document.querySelector('cart-drawer');
    const id = Number(btn.dataset.plSwapVariant);
    try {
      // Ein Request: Einzelkissen raus, 2er-Set rein (kein kurzer Leer-Zustand)
      const keyRes = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.plSwapKey, quantity: 0 }),
      });
      if (!keyRes.ok) throw new Error('change');
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (drawer && drawer.contains(btn) && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents({ ...data, id });
        // Dawn setzt beim kurz leeren Warenkorb "is-empty" – wieder entfernen, sonst bleibt die Artikelliste unsichtbar
        drawer.classList.remove('is-empty');
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      } else {
        window.location.reload();
      }
    } catch (err) {
      window.location.reload();
    }
  });

  class PlQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.pl-quiz__step')];
      this.reset();
      this.querySelector('[data-quiz-start]')?.addEventListener('click', () => this.go(1));
      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => { this.reset(); this.go(0); });
      this.querySelectorAll('.pl-quiz__answer').forEach((b) => b.addEventListener('click', () => this.answer(b)));
    }
    reset() { this.a = 0; this.b = 0; this.flags = []; this.idx = 0; }
    go(i) {
      this.idx = i;
      this.steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      const active = this.steps[i];
      active?.querySelector('button, a')?.focus({ preventScroll: true });
    }
    answer(btn) {
      this.a += parseInt(btn.dataset.a, 10) || 0;
      this.b += parseInt(btn.dataset.b, 10) || 0;
      if (btn.dataset.flag) this.flags.push(btn.dataset.flag);
      const next = this.idx + 1;
      if (next < this.steps.length - 1) this.go(next); else this.result();
    }
    result() {
      const key = this.a > this.b ? 'a' : this.b > this.a ? 'b' : 'duo';
      this.querySelectorAll('[data-result]').forEach((r) => { r.hidden = r.dataset.result !== key; });
      const colors = { weiss: 'Wolkenweiß', gelb: 'Rosé', rose: 'Rosé', grau: 'Nebelgrau' };
      const color = this.flags.find((f) => colors[f]);
      const colorEl = this.querySelector('[data-quiz-color]');
      if (colorEl) colorEl.textContent = key === 'b' && color ? `in ${colors[color]}` : '';
      const hint = this.querySelector('[data-quiz-hint]');
      if (hint) {
        const txt = this.flags.includes('set') ? this.dataset.hintSet : this.flags.includes('gift') ? this.dataset.hintGift : '';
        hint.textContent = txt || '';
        hint.hidden = !txt;
      }
      this.go(this.steps.length - 1);
    }
  }
  if (!customElements.get('pl-quiz')) customElements.define('pl-quiz', PlQuiz);
})();

(() => {
  const COLORS = { "wolkenweiß": "#FAFAF7", "vanillegelb": "#F6E7A8", "nebelgrau": "#C9CBCF", "lavendel": "#D9CCF2", "rosé": "#F7C6D3", "rose": "#F7C6D3", "himmelblau": "#BFD9F2", "creme & rosé": "linear-gradient(135deg,#F6EFE3 50%,#F2B8C8 50%)", "creme & himmelblau": "linear-gradient(135deg,#F6EFE3 50%,#B5D3F0 50%)", "creme & salbei": "linear-gradient(135deg,#F6EFE3 50%,#C9D8C5 50%)", "blau": "#BFD9F2", "weiß": "#FAFAF7", "gelb": "#F6E7A8", "grau": "#C9CBCF" };
  const decorateSwatches = () => {
    document.querySelectorAll("variant-selects fieldset").forEach((fs) => {
      const legend = fs.querySelector("legend");
      if (!legend || !/farbe|color|colour/i.test(legend.textContent)) return;
      fs.classList.add("pl-swatches");
      fs.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = fs.querySelector(`label[for="${input.id}"]`);
        const c = COLORS[(input.value || "").toLowerCase()];
        if (label && c && !label.querySelector(".pl-sw")) { const sw = document.createElement("span"); sw.className = "pl-sw"; sw.style.setProperty("--sw", c); sw.setAttribute("aria-hidden", "true"); label.prepend(sw); }
      });
      const checked = fs.querySelector('input[type="radio"]:checked');
      let cur = legend.querySelector(".pl-swatches__current");
      if (!cur) { cur = document.createElement("span"); cur.className = "pl-swatches__current"; legend.appendChild(cur); }
      cur.textContent = checked ? `: ${checked.value}` : "";
    });
  };
  decorateSwatches();
  document.addEventListener("shopify:section:load", decorateSwatches);
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(decorateSwatches, 0));
})();
